import FormDataFileUploadDispatcherFactory from './FormDataFileUploadDispatcherFactory';
import { IFormDataFileUploadDispatcherFactoryMethod as IFormDataFileUploadDispatcherFactory } from './interfaces';
import { DIUploadTypes } from '../types';

export const { FormDataFileUploadDispatcher } = DIUploadTypes;

export type { IFormDataFileUploadDispatcherFactory };

export default FormDataFileUploadDispatcherFactory;
